import { BankAccountCard, ItemInfoType } from "interfaces";

export const getColumns = (data: BankAccountCard): Array<ItemInfoType> => {
  const { bankName, bankRegNum, bik, accountNumber, correspondentAccount } = data;

  return [
    {
      label: "Банк получатель",
      text: `${bankName}`,
    },
    {
      label: "Регистрационный номер банка по КГРКО",
      text: `${bankRegNum}`,
    },
    {
      label: "БИК",
      text: `${bik}`,
    },
    {
      label: "Расчетный счет",
      text: `${accountNumber}`,
    },
    {
      label: "Кор. счет",
      text: `${correspondentAccount}`,
    },
  ].filter((c) => !!c) as ItemInfoType[];
};
